import React, { PureComponent } from "react";
import SelectWithLabel from '../../../Common/Components/SelectWithLabel';

class SelectBranch extends PureComponent {

    render() {

      let mensajeErrorSucursal = null;
      let mensajeErrorLiquidacion = null;
      let mensajeErrorGrupo = null;

      const { Validaciones, ValidarPantalla, GET_MODELO_LIQUIDACION, GET_GRUPO_AFINIDAD, GET_SUCURSAL, Cuenta ,seleccionarCombo } = this.props;
      const { SucursalId, GrupoAfinidadId, ModeloLiquidacionId } = Cuenta;

      const optionSucursales = GET_SUCURSAL.map((sucursal, index) => {
         return (
         <option value={sucursal.Id} key={"sucursal-option-" + index} data-codigo={sucursal.Codigo}>
            {sucursal.Codigo + " - " + sucursal.Descripcion}
         </option>
         );
      });

      const optionModeloLiquidacion = GET_MODELO_LIQUIDACION.map((modelo, index) => {
        return (
        <option value={modelo.Id} key={"modelo-option-" + index} data-codigo={modelo.Codigo}>
            {modelo.Descripcion}
        </option>
        );
      });

      const optionAfinidades = GET_GRUPO_AFINIDAD.map((afinidad, index) => {
        return (
        <option value={afinidad.Id} key={"afinidad-option-" + index} data-codigo={afinidad.Codigo}>
            {afinidad.Descripcion}
        </option>
        );
      });

      if (ValidarPantalla == true)
      {

         const { SucursalSeleccionada, ModeloLiquidacionSeleccionado, GrupoAfinidadSeleccionado } = Validaciones;

         if (SucursalSeleccionada == false) {
             mensajeErrorSucursal = <label className="error">Debe seleccionar al menos una sucursal</label>;
         }

         if (ModeloLiquidacionSeleccionado == false) {
             mensajeErrorLiquidacion = <label className="error">Debe seleccionar al menos un modelo de liquidación</label>
         }

         if (GrupoAfinidadSeleccionado == false) {
                mensajeErrorGrupo = <label className="error">Debe seleccionar al menos un grupo de afinidad</label>
         }

      }

      return (
      <div className="row">

        <div className="col-xs-12 bottom-separator-xs">
            <SelectWithLabel
                mensajeError={mensajeErrorSucursal}
                options={optionSucursales}
                seleccionarCombo={seleccionarCombo}
                value={SucursalId}
                nombreCombo="SUCURSAL"
                titulo="Sucursal"
            />
        </div>

        <div className="col-xs-12 bottom-separator-xs">
            <SelectWithLabel
                mensajeError={mensajeErrorLiquidacion}
                options={optionModeloLiquidacion}
                seleccionarCombo={seleccionarCombo}
                value={ModeloLiquidacionId}
                nombreCombo="MODELO-LIQUIDACION"
                titulo="Modelo de liquidación"
            />
        </div>

        <div className="col-xs-12 bottom-separator-xs">
            <SelectWithLabel
                mensajeError={mensajeErrorGrupo}
                options={optionAfinidades}
                seleccionarCombo={seleccionarCombo}
                value={GrupoAfinidadId}
                nombreCombo="GRUPO-AFINIDAD"
                titulo="Grupo de afinidad"
            />
        </div>

      </div>
      );

    }
}

export default SelectBranch;